/* @ngInject */

export default ($compile) => {
  function getTemplate(model) {
    var _template = '';
    switch (model.type) {
      case 'boolean':
        _template +=
          '<div ng-show="createModel.isSelected" class="field-container filter" flex>';
        _template += '<h5 class="field-caption">Value</h5>';
        _template +=
          '<md-radio-group class="md-primary" ng-model="createModel.value" layout="row" flex>';
        _template += '<md-radio-button value="true">Yes</md-radio-button>';
        _template += '<md-radio-button value="false">No</md-radio-button>';
        _template += '</md-radio-group>';
        _template += '</div>';
        break;
      case 'date':
        _template +=
          '<div ng-show="createModel.isSelected" class="field-container filter" layout="column" flex>';
        _template += '<div layout="row">';
        _template += '<div flex="50">';
        _template += '<h5 class="field-caption">Relative from</h5>';
        _template += '<md-select ng-model="createModel.value.from" aria-label="Relative from">';
        _template += '<md-option ng-value="undefined">Any time</md-option>';
        _template += '<md-option ng-value="\'now-12M/M\'">12 months ago</md-option>';
        _template += '<md-option ng-value="\'now-11M/M\'">11 months ago</md-option>';
        _template += '<md-option ng-value="\'now-10M/M\'">10 months ago</md-option>';
        _template += '<md-option ng-value="\'now-9M/M\'">9 months ago</md-option>';
        _template += '<md-option ng-value="\'now-8M/M\'">8 months ago</md-option>';
        _template += '<md-option ng-value="\'now-7M/M\'">7 months ago</md-option>';
        _template += '<md-option ng-value="\'now-6M/M\'">6 months ago</md-option>';
        _template += '<md-option ng-value="\'now-5M/M\'">5 months ago</md-option>';
        _template += '<md-option ng-value="\'now-4M/M\'">4 months ago</md-option>';
        _template += '<md-option ng-value="\'now-3M/M\'">3 months ago</md-option>';
        _template += '<md-option ng-value="\'now-2M/M\'">2 months ago</md-option>';
        _template += '<md-option ng-value="\'now-1M/M\'">1 month ago</md-option>';
        _template += '<md-option ng-value="\'now/M\'">This month</md-option>';
        _template += '<md-option ng-value="\'now+1M/M\'">1 month away</md-option>';
        _template += '<md-option ng-value="\'now+2M/M\'">2 months away</md-option>';
        _template += '<md-option ng-value="\'now+3M/M\'">3 months away</md-option>';
        _template += '<md-option ng-value="\'now+4M/M\'">4 months away</md-option>';
        _template += '<md-option ng-value="\'now+5M/M\'">5 months away</md-option>';
        _template += '<md-option ng-value="\'now+6M/M\'">6 months away</md-option>';
        _template += '<md-option ng-value="\'now+7M/M\'">7 months away</md-option>';
        _template += '<md-option ng-value="\'now+8M/M\'">8 months away</md-option>';
        _template += '<md-option ng-value="\'now+9M/M\'">9 months away</md-option>';
        _template += '<md-option ng-value="\'now+10M/M\'">10 months away</md-option>';
        _template += '<md-option ng-value="\'now+11M/M\'">11 months away</md-option>';
        _template += '<md-option ng-value="\'now+12M/M\'">12 months away</md-option>';
        _template += '</md-select>';
        _template += '</div>';
        _template += '<div flex="50">';
        _template += '<h5 class="field-caption">Relative to</h5>';
        _template += '<md-select ng-model="createModel.value.to" aria-label="Relative to">';
        _template += '<md-option ng-value="undefined">Any time</md-option>';
        _template += '<md-option ng-value="\'now-11M/M\'">12 months ago</md-option>';
        _template += '<md-option ng-value="\'now-10M/M\'">11 months ago</md-option>';
        _template += '<md-option ng-value="\'now-9M/M\'">10 months ago</md-option>';
        _template += '<md-option ng-value="\'now-8M/M\'">9 months ago</md-option>';
        _template += '<md-option ng-value="\'now-7M/M\'">8 months ago</md-option>';
        _template += '<md-option ng-value="\'now-6M/M\'">7 months ago</md-option>';
        _template += '<md-option ng-value="\'now-5M/M\'">6 months ago</md-option>';
        _template += '<md-option ng-value="\'now-4M/M\'">5 months ago</md-option>';
        _template += '<md-option ng-value="\'now-3M/M\'">4 months ago</md-option>';
        _template += '<md-option ng-value="\'now-2M/M\'">3 months ago</md-option>';
        _template += '<md-option ng-value="\'now-1M/M\'">2 months ago</md-option>';
        _template += '<md-option ng-value="\'now/M\'">1 month ago</md-option>';
        _template += '<md-option ng-value="\'now+1M/M\'">This month</md-option>';
        _template += '<md-option ng-value="\'now+2M/M\'">1 month away</md-option>';
        _template += '<md-option ng-value="\'now+3M/M\'">2 months away</md-option>';
        _template += '<md-option ng-value="\'now+4M/M\'">3 months away</md-option>';
        _template += '<md-option ng-value="\'now+5M/M\'">4 months away</md-option>';
        _template += '<md-option ng-value="\'now+6M/M\'">5 months away</md-option>';
        _template += '<md-option ng-value="\'now+7M/M\'">6 months away</md-option>';
        _template += '<md-option ng-value="\'now+8M/M\'">7 months away</md-option>';
        _template += '<md-option ng-value="\'now+9M/M\'">8 months away</md-option>';
        _template += '<md-option ng-value="\'now+10M/M\'">9 months away</md-option>';
        _template += '<md-option ng-value="\'now+11M/M\'">10 months away</md-option>';
        _template += '<md-option ng-value="\'now+12M/M\'">11 months away</md-option>';
        _template += '<md-option ng-value="\'now+13M/M\'">12 months away</md-option>';
        _template += '</md-select>';
        _template += '</div>';
        _template += '</div>';
        _template += '<div layout="row">';
        _template += '<div flex="50"><h5 class="field-caption">Absolute from</h5>';
        _template +=
          '<md-datepicker customize ng-disabled="createModel.value.from" ng-model="createModel.value.fromAbs">';
        _template += '</md-datepicker></div>';
        _template += '<div flex="50"><h5 class="field-caption">Absolute to</h5>';
        _template +=
          '<md-datepicker customize ng-disabled="createModel.value.to" ng-model="createModel.value.toAbs">';
        _template += '</md-datepicker></div>';
        _template += '</div>';
        _template += '</div>';
        break;
      case 'number':
        _template +=
          '<div ng-show="createModel.isSelected" class="field-container filter" layout="row" flex>';
        _template +=
          '<md-input-container flex="50"><h5 class="field-caption">Minimum</h5><input type="number" ng-model="createModel.valueFrom"></md-input-container>';
        _template +=
          '<md-input-container flex="50"><h5 class="field-caption">Maximum</h5><input type="number" ng-model="createModel.valueTo"></md-input-container>';
        _template += '</div>';
        break;
      case 'string':
        _template +=
          '<div ng-show="createModel.isSelected" class="field-container filter" layout="row" flex>';
        _template +=
          '<md-input-container flex="100" md-no-float><h5 class="field-caption">Value</h5><input type="text" ng-model="createModel.value"></md-input-container>';
        _template += '</div>';
        break;
      default:
        _template += '';
        break;
    }
    return _template;
  }
  return {
    restrict: 'E',
    scope: {
      createModel: '=',
      toggleChanges: '&'
    },
    link: function (scope, element, attrs) {
      var template = $compile(getTemplate(scope.createModel))(scope);
      element.replaceWith(template);
    }
  };
};
